import React from "react";

type Props = {
  children: React.ReactNode;
  className?: string;
};

/**
 * Standard page-content width used across the design (max 1320px, horizontal padding).
 */
const Container = ({ children, className = "" }: Props) => (
  <div className={`mx-auto w-full max-w-[1320px] px-6 md:px-12 ${className}`}>
    {children}
  </div>
);

export default Container;
